
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import { connect } from "react-redux";
import { UIMixin } from "../../../mixins/uiMixin";
import PropTypes from "prop-types";
import Zergling from '../../../helpers/zergling';

class BetHistoryCashout extends Component {
    constructor (props) {
        super(props);
        this.sendCashoutAmount = this.sendCashoutAmount.bind(this);
        this.state = {
            betCashoutChanged: false,
            newPrice: null
        };
    }

    sendCashoutAmount () {
        let {betId, price} = this.props;
        if (this.state.newPrice) {
            price = this.state.newPrice;
        }
        Zergling.get({'bet_id': betId, 'price': price}, 'cashout')
            .then((data) => {
                if (data.result === "Fail") {
                    this.setState({
                        betCashoutChanged: true,
                        newPrice: data.details.new_price
                    });
                } else if (data.result !== "Ok") {
                    let errorMessage = data.result_text;
                    this.props.closePopup()();
                    this.props.openPopup("errorPopup", {errorMessage, onClose: this.props.onClose})();
                } else {
                    if (this.props.onClose)
                        this.props.onClose?.()()
                    else
                        this.props.closePopup()();
                }
            })
            .catch();
    }

    render () {
        console.log(this.props, 'ppp')
        return Template.default.apply(this); //eslint-disable-line no-undef
    }

}

BetHistoryCashout.propTypes = {
    closePopup: PropTypes.func,
    openPopup: PropTypes.func,
    price: PropTypes.number,
    betId: PropTypes.number
};

export default connect()(UIMixin({Component: BetHistoryCashout}));